import { LegacyQrWaiterContactDetailsStorageManager } from "./LegacyQrWaiterContactDetailsStorageManger";
export const QR_WAITER_CONTACT_DETAILS_KEY = "client_contactDetails_qr_waiter";
export class QrWaiterContactDetailsStorageManager {
    store(contactDetails) {
        const contactDetailsDataString = JSON.stringify(contactDetails);
        localStorage.setItem(QR_WAITER_CONTACT_DETAILS_KEY, contactDetailsDataString);
    }
    restore() {
        const contactDetailsDataString = localStorage.getItem(QR_WAITER_CONTACT_DETAILS_KEY);
        if (contactDetailsDataString === null) {
            return new LegacyQrWaiterContactDetailsStorageManager().restore();
        }
        return JSON.parse(contactDetailsDataString);
    }
    erase() {
        localStorage.removeItem(QR_WAITER_CONTACT_DETAILS_KEY);
    }
}
